import React, { useEffect, useMemo, useState } from 'react';
import { openReasonsDialog, refundTitles } from "./utiles";
import { uniqBy } from "lodash";
import { useStyles } from "./styles"
import { useTranslation } from 'react-i18next';
import { InfoCard } from "./InfoCard";
import { IPlacedOrder, IProcessedOrdersDetails, IOrderItem, TaxType } from '../constants'
import useFormatCurrency from '../../../yoello-lib/modules/localisation/useCurrency';
import { ItemQuantitySelect } from "./ItemQuantitySelect"
import { ConfirmationModal } from './ConfirmationModal';
import { useHandleConfirmationModal } from "./useHandleConfirmationModal"
import { RefundActionType } from './types';
import { IMultiDialogChildren } from '../../dialogRoutes/MultiDialogRoute';
import { useDialogRouteStages } from '../../dialogRoutes/useDialogRouteStages';
import { dialogKeys, REFUND_REASONS_URL } from '../../../const/URL.const';
import { useDialogClose } from '../../dialogRoutes/useDialogClose';
import AdvancedChecklist from '../../../yoello-lib/modules/components/UI/Lists/AdvancedChecklist';
import { Alert } from '@material-ui/lab';
interface OrderDetailsChecklistDialogProps extends IMultiDialogChildren {
  orderDetails: IProcessedOrdersDetails;
  callPlacedOrders: any;
  placedOrder: IPlacedOrder,
  refundActionType: RefundActionType,
  isRefund: boolean
}

export function contentMarkup(title: string, className: string, subTitle?: string) {
  return <div className={className} >
    <div data-component-name="MENU_ITEM_NAME_PUBLIC">
      <p>{title}</p>
      {subTitle && <span>{subTitle}</span>}
    </div>
  </div>
};

export function OrderDetailsChecklistDialog({ orderDetails, refundActionType, placedOrder, isRefund, callPlacedOrders, ...props }: OrderDetailsChecklistDialogProps) {
  const { t } = useTranslation();
  useDialogClose(props);

  const { setIsOpen, isOpen } = useHandleConfirmationModal();
  const { goToNextStep, goToPrevStep, setProps, getProps } = useDialogRouteStages(props.history);
  const { formatCurrency } = useFormatCurrency();
  const [SelectedQuantities, setSelectedQuantities] = useState<Record<string, number>>({})
  const [totalRefundedPrice, setTotalRefundedPrice] = useState<number>(0)
  const [itemsList, setItemsList] = useState<any[]>([])
  const [latestSelectedItems, setLatestSelectedItems] = useState<any[]>([])
  const classes = useStyles();
  const { SpecificItemsDialogLabel } = refundTitles[refundActionType ?? RefundActionType.DECLINE];
  const { InfoCardTitle, InfoCardContent } = refundTitles[RefundActionType.REFUND]
  // This is for charges
  // const placedOrderDetailsArray = getPlacedOrderDetails(placedOrder);

  useEffect(() => {
    // const selectedItems = getProps(dialogKeys.SPECIFICITEMSREFUND, "selectedItems");
    let items: any[] = [];
    if (Array.isArray(orderDetails?.in_order) && orderDetails?.in_order.length > 0) {
      orderDetails.in_order.forEach((order: IOrderItem) => {
        if (refundActionType === RefundActionType.DECLINE) {
          items.push(order);
          items = uniqBy(items, "menu_item_id")
        } else {
          if (order.in_order_group_quantity - order.in_order_group_quantity_refunded > 0 && !order.in_order_sold_as_extra) {
            items.push(order)
          }
        }
      });
      // this section is for considering charges refund
      // const placedOrderDetails = createSpecificItemsCheckListArray(placedOrder , selectedItems , classes)
      // setItemsList([...items, ...placedOrderDetails]);
      setItemsList(items)
    }
    // eslint-disable-next-line
  }, []);
  function handleChange(quantity: number, item: IOrderItem) {
    const items = SelectedQuantities;
    items[item.in_order_id] = quantity;
    setSelectedQuantities(items);
  };

  function renderItemQuantity(selectedItems: any[], item?: IOrderItem) {
    if (item) {
      return <ItemQuantitySelect
        SelectedQuantities={SelectedQuantities}
        onClick={(quantity: number) => { handleChange(quantity, item); selectedItemsOnChange(selectedItems) }}
        id={item.in_order_id}
        itemQuantity={item.in_order_group_quantity - item.in_order_group_quantity_refunded}
      />
    }
    else return null
  }

  function renderItemPrice(id: string, item?: IOrderItem) {
    const inOrderIdsPrice: Record<string, number> = getProps(dialogKeys.ORDER, "inOrderIdsPrice")
    if (item) {
      let itemPrice = item.in_order_item_discount_code_price ?? item.in_order_item_discount_price;
      if(placedOrder.tax_inclusion_type === TaxType.ADDITIVE){
        itemPrice+=item.in_order_item_vat_amount
      }
      orderDetails.in_order.forEach((order: IOrderItem) => {
        if (item.in_order_id === order.in_order_sold_with_in_order_item_id) {
          itemPrice += ((order.in_order_item_discount_code_price ?? order.in_order_item_discount_price) * (order.in_order_group_quantity / item.in_order_group_quantity))
          if(placedOrder.tax_inclusion_type === TaxType.ADDITIVE){
            itemPrice+=(order.in_order_item_vat_amount * (order.in_order_group_quantity / item.in_order_group_quantity))
          }
        }
      });
      if (inOrderIdsPrice) {
        inOrderIdsPrice[item.in_order_id] = itemPrice;
        setProps(dialogKeys.ORDER, "inOrderIdsPrice", inOrderIdsPrice);
      } else {
        setProps(dialogKeys.ORDER, "inOrderIdsPrice", { [item.in_order_id]: itemPrice });
      }
      return formatCurrency(itemPrice)
    }
    // this is for charges
    // else {
    //   const item = placedOrderDetailsArray.find(({ id: placedOrderDetails_id }: { id: string }) => placedOrderDetails_id === id)!
    //   return formatCurrency(item.value)
    // }
  }

  function Toolbar(id: string, getSelected: () => any[]) {
    const selectedItems: any[] = getSelected();
    const item: IOrderItem | undefined = orderDetails.in_order.find((order: IOrderItem) => order.in_order_id === id)!
    return <div className={classes.ToolbarContainer} onClick={(e) => { e.stopPropagation() }}>
      <div>{renderItemQuantity(selectedItems, item)}</div>
      <p>x</p>
      <div data-component-name="ITEM_TOTAL_PRICE">{renderItemPrice(id, item)}</div>
    </div>
  };
  function onSubmit(selectedItems: any[]) {
    if (selectedItems.length > 0) {
      setProps(dialogKeys.SPECIFICITEMSREFUND, "selectedItems", selectedItems);
      if (isRefund) {
        openReasonsDialog(dialogKeys.SPECIFICITEMSREFUND, dialogKeys.PARTIALREFUNDREASONS, `${props.routePath}/${placedOrder.placed_order_id}${REFUND_REASONS_URL}`,
          isRefund, placedOrder, t, goToNextStep, goToPrevStep, orderDetails, undefined, totalRefundedPrice)
      } else {
        setIsOpen(true)
      }
    }
  }

  function selectedItemsOnChange(selectedItems: any[]) {
    setLatestSelectedItems(selectedItems)
    const inOrderIdsPrice: Record<string, number> = getProps(dialogKeys.ORDER, "inOrderIdsPrice");
    let totalPrice = 0;
    let inOrderIds: Record<string, number> = {}
    let menuItemIds: string[] = [];
    selectedItems.forEach((item: any) => {
      orderDetails.in_order.forEach((order: IOrderItem) => {
        if (item.in_order_id === order.in_order_id) {
          if (isRefund) {
            const quantity: number = SelectedQuantities[item.in_order_id] ?? order.in_order_group_quantity - order.in_order_group_quantity_refunded;
            totalPrice += quantity * inOrderIdsPrice[item.in_order_id]
            inOrderIds[order.in_order_id] = quantity;
          }
          menuItemIds.push(order.menu_item_id);
        }
      })

      // this is for charges
      // const placedOrderDetailsItem = placedOrderDetailsArray.find(({ id: placedOrderDetails_id }: { id: string }) => placedOrderDetails_id === item.id)!;
      // if(placedOrderDetailsItem){
      //   totalPrice +=placedOrderDetailsItem.value
      // }
    })
    setProps(dialogKeys.ORDER, "inOrderIds", inOrderIds);
    setProps(dialogKeys.ORDER, "selectedMenuItemIds", menuItemIds);
    setTotalRefundedPrice(isRefund ? totalPrice : placedOrder?.placed_order_order_total)
  }
  
  const hasReachedTotalRefundValue = useMemo(() => {
    // Check if all items are selected
    const allItemsSelected =
      itemsList.length > 0 && latestSelectedItems.length === itemsList.length;

    // Check if all item quantities are maxed out (considering 0 as maxed out)
    const allQuantitiesMaxedOut = itemsList.every((item) => {
      const quantity = SelectedQuantities[item.in_order_id] || 0;
      return (
        quantity === 0 ||
        quantity ===
          item.in_order_group_quantity - item.in_order_group_quantity_refunded
      );
    });

    // Return true if both conditions are met
    return allItemsSelected && allQuantitiesMaxedOut;
  }, [itemsList, latestSelectedItems, SelectedQuantities]);
   
  return (<>
    <div className={classes.CheckListRoot}>
      <AdvancedChecklist
        isDisabled={hasReachedTotalRefundValue}
        listData={itemsList}
        mainLabelKey={"menu_item_name_public"}
        subLabelKey={"in_order_pricing_option_name"}
        itemToolbar={isRefund ? Toolbar : undefined}
        onSubmit={onSubmit}
        onItemSelectionChange={selectedItemsOnChange}
        hasSubmitCancelButtons={true}
        InfoCard={!isRefund && <section className={classes.ChekListInfoCard}><InfoCard title={t(InfoCardTitle)} content={t(InfoCardContent)} /></section>}
        idKey={"in_order_id"}
        selectedItems={getProps(dialogKeys.SPECIFICITEMSREFUND, "selectedItems")}
        headerDescription={t(SpecificItemsDialogLabel)}
        onCancel={props.onClose}
        mandatorySelection={true}
        submitButtonText={t("PartialReafund.Buttons.ConfirmSelection") as string}
        cancelButtonText={t("PartialReafund.Buttons.Back") as string}
      />
    </div>
    {isRefund && <footer className={classes.totalRefundedPrice}>
      {hasReachedTotalRefundValue && (
        <Alert severity="error">{t("PartialReafund.TotalRefundError")}</Alert>
      )}

      <p>{t("PartialReafund.TotalRefundValue")}</p>
      <p data-component-name="SELECTED_ITEMS_TOTAL_PRICE">{formatCurrency(totalRefundedPrice)}</p>
    </footer>}
    <ConfirmationModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      refundActionType={refundActionType}
      totalRefundedValue={totalRefundedPrice}
      placedOrder={placedOrder}
      history={props.history}
      path={props.routePath}
      venueId={props.venueId}
    />
  </>
  )
}
